import {applyCataloguePrice} from '../../utils/servicePrices';
import { createSlice } from "@reduxjs/toolkit";
import initialState from "./initial.value";

// NOTE: `reducers` is intentionally empty and every case lives in `extraReducers`
// matched by literal string type (not the auto-generated `rootReducer/xxx` type
// createSlice would produce for entries in `reducers`). This is required because
// the plain action creators in `./action.jsx` are dispatched all over the app as
// `{ type: "Product_list", payload }` etc. — matching on the literal legacy type
// string keeps every existing dispatch call site working unchanged.
const rootReducerSlice = createSlice({
  name: "rootReducer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("Product_list", (state, action) => {
        state.product_list = action.payload;
      })
      .addCase("Dashbaord_RecentProduct", (state, action) => {
        state.dashboard_recentproduct = action.payload;
      })
      .addCase("Dashbaord_ExpiredProduct", (state, action) => {
        state.dashboard_expiredproduct = action.payload;
      })
      .addCase("Salesdashbaord_ExpiredProduct", (state, action) => {
        state.saleshdashboard_recenttransaction = action.payload;
      })
      .addCase("Brand_list", (state, action) => {
        state.brand_list = action.payload;
      })
      .addCase("Unit_Data", (state, action) => {
        state.unit_data = action.payload;
      })
      .addCase("Variantattribute_Data", (state, action) => {
        state.variantattributes_data = action.payload;
      })
      .addCase("Warranty_Data", (state, action) => {
        state.warranty_data = action.payload;
      })
      .addCase("Barcode_Data", (state, action) => {
        state.barcode_data = action.payload;
      })
      .addCase("Department_Data", (state, action) => {
        state.departmentlist_data = action.payload;
      })
      .addCase("Designation_Data", (state, action) => {
        state.designation_data = action.payload;
      })
      .addCase("Shiftlist_Data", (state, action) => {
        state.shiftlist_data = action.payload;
      })
      .addCase("Attendenceemployee_Data", (state, action) => {
        state.attendenceemployee_data = action.payload;
      })
      .addCase("toggle_header", (state, action) => {
        state.toggle_header = action.payload;
      })
      .addCase("Invoicereport_Data", (state, action) => {
        state.invoicereport_data = action.payload;
      })
      .addCase("Salesreturns_Data", (state, action) => {
        state.salesreturns_data = action.payload;
      })
      .addCase("Quatation_Data", (state, action) => {
        state.quotationlist_data = action.payload;
      })
      .addCase("Customer_data", (state, action) => {
        state.customerdata = action.payload;
      })
      .addCase("Userlist_data", (state, action) => {
        state.userlist_data = action.payload;
      })
      .addCase("Rolesandpermission_data", (state, action) => {
        state.rolesandpermission_data = action.payload;
      })
      .addCase("Deleteaccount_data", (state, action) => {
        state.deleteaccount_data = action.payload;
      })
      .addCase("Attendenceadmin_data", (state, action) => {
        state.attendanceadmin_data = action.payload;
      })
      .addCase("Leavesadmin_data", (state, action) => {
        state.leavesadmin_data = action.payload;
      })
      .addCase("Leavestype_data", (state, action) => {
        state.leavetypes_data = action.payload;
      })
      .addCase("Holiday_data", (state, action) => {
        state.holiday_data = action.payload;
      })
      .addCase("Expiredproduct_data", (state, action) => {
        state.expiredproduct_data = action.payload;
      })
      .addCase("Lowstock_data", (state, action) => {
        state.lowstock_data = action.payload;
      })
      .addCase("Categotylist_data", (state, action) => {
        state.categotylist_data = action.payload;
      })
      .addCase("Layoutstyle_data", (state, action) => {
        state.layoutstyledata = action.payload;
      })
      .addCase("User_infos", (state, action) => {
        state.user_infos = action.payload;
      })
      .addCase("User_location", (state, action) => {
        state.user_location = action.payload;
      })
      .addCase("Current_location", (state, action) => {
        state.current_location = action.payload;
      })
      .addCase("Products", (state, action) => {
        state.products = action.payload;
      })
      .addCase("ServicePriceUpdated", (state, action) => {
        if (String(state.user_infos?.establishmentId) === String(action.payload.establishmentId)) {
          state.products = applyCataloguePrice(state.products, action.payload);
        }
      })
      .addCase("Current_invoice", (state, action) => {
        state.current_invoice = action.payload;
      })
      .addCase("Invoice_list", (state, action) => {
        state.invoice_list = action.payload;
      })
      .addCase("Employees", (state, action) => {
        state.employees = action.payload;
      })
      .addCase("EventTypes", (state, action) => {
        state.eventTypes = action.payload;
      })
      .addCase("Printer_Params", (state, action) => {
        state.printerParams = action.payload;
      })
      .addCase("ExpenseTypes", (state, action) => {
        state.expenseTypes = action.payload;
      })
      .addCase("CashSession", (state, action) => {
        state.cashSession = action.payload;
      });
  },
});

export default rootReducerSlice.reducer;
